import { createContext } from 'react';
export const PersistentPageContext = createContext(false);
